import { render, staticRenderFns } from "./RankingOtsParts.vue?vue&type=template&id=9587604e&scoped=true"
import script from "./RankingOtsParts.vue?vue&type=script&lang=ts"
export * from "./RankingOtsParts.vue?vue&type=script&lang=ts"
import style0 from "./RankingOtsParts.vue?vue&type=style&index=0&id=9587604e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9587604e",
  null
  
)

export default component.exports